
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { State } from 'vuex-class';
import { validateWithScroll } from '~/lib/scrollValidator';

@Component({
    components: {
        popup: require('~/components/ui/dialog').default,
        btn: require('~/components/form/button/').default,
        loader: require('~/components/common/loader-block').default,
        formField: require('~/components/form/form-field/').default,
        VueRecaptcha: require('vue-recaptcha').default,
    }
})
export default class CheapRequestComponent extends Vue {

    @prop() private offerId: number;
    @State("user") private user: User;

    private show: boolean = false;
    private loading: boolean = false;

    private form = {
        phone: null,
        name: null,
        link: null,
        email: null,
        message: null,
    };

    private siteKey = '6LcNYskUAAAAAKJCkqqwtLbg6TIV-xBU7QEtI2oo';

    mounted() {
        if (this.user) {
            this.form.name = `${this.user.firstName} ${this.user.lastName}`.trim();
            this.form.email = this.user.email;
            this.form.phone = this.user.phone;
        }
    }

    startSend() {

        if (this.loading || !this.valid) {
            return;
        }

        this.loading = true;
        (this.$refs.invisibleRecaptcha as any).execute();
    }

    async sendRequest(/*response: string*/) {

        try {
            const result = await this.$store.dispatch('catalog/CheapRequest', {
                // token: response,
                product: this.offerId,
                form: this.form,
            });

            if (result.success) {
                this.show = false;
                this.$store.dispatch('SuccessFlash', 'Заявка успешно отправлена');
            } else {
                this.$store.dispatch('ErrorFlash', 'Ошибка при отправке заявки');
            }

        } catch (error) {
            this.$store.dispatch('ErrorFlash', 'Ошибка при отправке заявки');
        } finally {
            this.loading = false;
        }
    }

    open() {
        this.show = true;
    }

    get valid(): boolean {

        return validateWithScroll(this, ['nameField', 'emailField', 'phoneField', 'linkField']);
    }
}